import DocumentPreview from "../../components/DocumentPreview";
import Create from "./Create";
import Detail from "./Detail";
import List from "./List";
import SearchOrder from "./SearchOrder";

const routes = [
    {
        path: 'orders',
        element: <List />
    },
    {
        path: 'searchOrder',
        element: <SearchOrder />
    },
    {
        path: 'orders/create',
        element: <Create />
    },
    {
        path: 'orders/document/:id',
        element: <DocumentPreview />
    },
    {
        path: 'orders/:id',
        element: <Detail />
    }
]
export default routes;